import { render, staticRenderFns } from "./packages.vue?vue&type=template&id=74425534&"
import script from "./packages.vue?vue&type=script&lang=js&"
export * from "./packages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports